module.exports = "/_next/static/images/41277f7facf174c3a47d739c30376548-nubanker-pm@0.75x.jpg.webp";